<template>
  <Modal
    :open="props.open"
    hide-header
    customHeight="h-auto max-h-[80vh]"
    :hide-footer="true"
    :hide-header="true"
  >
    <template #modal-body>
      <div class="absolute right-8 top-8">
        <Button
          variant="paper-primary"
          size="sm"
          @click="$emit('close-modal')"
          class="hidden md:flex"
        >
          <template #icon>
            <Icon name="X" class="h-4 w-4 text-cta-tertiary-outline-icon" />
          </template>
        </Button>
      </div>

      <div class="p-8 grid grid-cols-1 md:grid-cols-2 gap-10">
        <OfferingCard :offering="s1_offering" class="col-span-1 !p-0" />
        <div class="col-span-1 flex flex-col gap-6">
          <AsteriskNotice text="Registered Offering Quiet Period" size="large" />
          <h3 class="text-4xl text-strongest font-semibold">Fund your investment today.</h3>
          <div class="flex flex-col gap-2">
            <div v-for="message in messages" class="flex items-start gap-[.875rem]">
              <Icon
                name="Asterisk"
                class="text-info min-h-5.5 min-w-5.5 h-5.5 w-5.5 -skew-x-12 pt-0.5"
              />
              <p class="text-[16px] text-strongest font-medium font-inter">
                {{ message }}
              </p>
            </div>
          </div>
          <div class="flex gap-2 items-center">
            <Button variant="always-primary" size="lg" @click="$emit('close-modal')" class="w-fit">
              <template #label> I understand </template>
            </Button>
            <Button
              variant="paper-primary"
              size="lg"
              @click="$emit('close-modal')"
              class="w-fit md:hidden"
            >
              <template #label> Go Back </template>
            </Button>
          </div>
        </div>
      </div>
      <p class="px-8 pb-4 text-xxs text-light">
        Phoenix Energy One, LLC (“Phoenix Energy”) is conducting offerings of debt securities
        pursuant to (i) an exemption from registration provided by Rule 506(c) of Regulation D (the
        “Private Placement Offering”) of the Securities Act of 1933, as amended (the “Act”) and (ii)
        a registration statement on Form S-1 under the Act (including a prospectus) filed with the
        Securities and Exchange Commission (the “SEC”) (the “Registered Offering”). In addition,
        Adamantium Capital, a wholly owned financing subsidiary of Phoenix Energy, is conducting an
        offering of debt securities pursuant to Rule 506(c) of Regulation D of the Act (the
        “Adamantium Offering”) and loans the proceeds of such offering to Phoenix Energy as its
        sponsor. The debt securities are offered through registered broker dealer(s) that are
        members of FINRA/ SIPC (finra.org/sipic.org), that are not affiliated with Phoenix Energy,
        although certain non-executive personnel of Phoenix Energy are registered representatives of
        a broker dealer and receive commissions for sales of the debt securities in the offerings.
        Only “accredited investors”, as such term is defined in Rule 501 of Regulation D of the Act,
        may invest in the Private Placement Offering or the Adamantium Offering. Participation in
        any of the offerings is subject to certain criteria, including meeting financial suitability
        requirements. Before investing, investors should read all of the offering documentation for
        the relevant offering, including, the prospectus for the Registered Offering, and all
        documents Phoenix Energy has filed with the SEC, which you may get for free by visiting
        EDGAR on the SEC’s website at sec.gov. Alternatively, Phoenix Energy can arrange to send you
        any applicable offering documents you request at phxoffering.com. The debt securities
        offered by Phoenix Energy and Adamantium Capital are speculative, unsecured, illiquid, and
        you may lose some or all of your investment. Past performance is not indicative of future
        results.
      </p>
    </template>
  </Modal>
</template>

<script setup>
import { Modal, Icon, Button, AsteriskNotice } from "@/components";
import OfferingCard from "@/pages/PurchaseFlow/OfferingCard.vue";
import offeringIcon_S1 from "@/assets/images/investment_silver_circle.png";

const s1_offering = {
  id: 1,
  name: "Registered Offering (S1)",
  bond_term: 60,
  interest_rate: 12,
  issuer: "PCG Holdings",
  minimum_investment: 5000,
  type: "S1",
  icon: offeringIcon_S1,
  is_short_term: false,
};

const messages = [
  "We are in a quiet period.",
  "You may submit your investment and payment during this period.",
  "Your signature and final documentation will be collected once the quiet period concludes.",
  "We'll notify you when it's time to return and finalize your investment.",
];

const emit = defineEmits(["close-modal"]);

const props = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
});
</script>
